var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


//////////////////
// WEBPACK FOOTER
// /app/~/core-js/library/modules/_core.js
// module id = ../../../../core-js/library/modules/_core.js
// module chunks = 7